import * as actionTypes from 'actions';
import pagesArray from 'constants/pages'

// let userData = localStorage.getItem('userData');
let userData = localStorage.getItem('userData');
let user = userData ? JSON.parse(userData) : null;

let newPages = [
  {
    title: 'Pages',
    pages: []
  }
]

const sandeep = (data) => {
  console.log(data, 'sandeep data');
  const pages = [
    {
      title: 'Pages',
      pages: []
    }
  ]
  if (data && data !== null && data.Pageaccess) {
    const newAccess = data && data.Pageaccess.split`,`.map(x => +x)
    console.log(newAccess);
    newAccess.map(access => {
      pagesArray[0].pages.filter(page => {
        if (access == page.id) {
          return pages[0].pages.push(page)
        }
      })
    })
  }
  userData = localStorage.getItem('userData');
  user = userData ? JSON.parse(userData) : null;
  console.log(pages, 'pages pages');
  newPages = pages
  return newPages;
}

const initialState = {
  loggedIn: JSON.parse(userData) != null ? true : false,
  user: user,
  pages: newPages
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    // case '@@INIT': {
    //   return {
    //     ...state,
    //     pages: sandeep(user)
    //   }
    // }
    case actionTypes.SESSION_LOGIN: {
      return {
        ...state,
        user: action.payload,
        loggedIn: true,
        pages: sandeep(action.payload)

      };
    }
    case actionTypes.SESSION_LOGOUT: {
      localStorage.setItem('userData', null);
      return {
        ...state,
        loggedIn: false,
        user: {},
        pages: [
          {
            title: 'Pages',
            pages: []
          }
        ]
      };
    }
    default: {
      return {
        ...state,
        pages: sandeep(user)
      };
    }
  }
};

export default sessionReducer;
